import React, { useState } from "react";
import Tooltip from "../../components/Tooltip";
import planComparisonData from "./data-renderer/PlanComparisonData";
import infoSvg from "../../assets/images/plan-comparison/svg/info.svg";
import dropDownSvg from "../../assets/images/plan-comparison/svg/dropdown.svg";

function PlanComparison() {
  const [expandedRows, setExpandedRows] = useState({});

  const sectionHeaders = [
    { id: "section-2", title: "Base Covers" },
    { id: "section-13", title: "Value Added Covers" },
    { id: "section-16", title: "Optional Covers" },
  ];

  const toggleExpand = (rowId, column) => {
    setExpandedRows((prev) => ({
      ...prev,
      [rowId]: {
        ...prev[rowId],
        [column]: !prev[rowId]?.[column],
      },
    }));
  };

  const renderCellContent = (content, rowId, column) => {
    const isExpanded = expandedRows[rowId]?.[column];
    const cellClass = isExpanded ? "" : "line-clamp-2 pr-6";

    if (Array.isArray(content)) {
      return (
        <div className={cellClass}>
          {content.map((line, index) => (
            <React.Fragment key={index}>
              {line}
              {index < content.length - 1 && <br />}
            </React.Fragment>
          ))}
        </div>
      );
    }
    return <div className={cellClass}>{content}</div>;
  };

  return (
    <div className="hidden lg:block px-6 lg:px-[120px]">
      <h1 className="text-[40px] leading-[54px] font-semibold text-center mb-6 lg:mb-10 text-[#27506E]">
        Plan Comparison
      </h1>
      <table id="plan-comparison-table" className="w-full">
        <thead>
          <tr className="bg-white text-left text-xl leading-8">
            {/* <th className="px-4 py-6 text-[#FB7C2F] text-nowrap">Sr. No.</th> */}
            <th className="px-4 py-6 text-[#FB7C2F]">Particulars</th>
            <th className="px-4 py-6 text-[#FB7C2F]">Pratham</th>
            <th className="px-4 py-6 text-[#FB7C2F]">Uttam</th>
            <th className="px-4 py-6 text-[#FB7C2F]">Param</th>
          </tr>
        </thead>
        <tbody>
          {planComparisonData.map((row, index) => (
            <React.Fragment key={row.id}>
              {sectionHeaders.some(
                (header) => header.id === `section-${row.id}`,
              ) && (
                <tr className="bg-[#B7E1FC] text-center">
                  <td className="p-2" colSpan="5">
                    {
                      sectionHeaders.find(
                        (header) => header.id === `section-${row.id}`,
                      ).title
                    }
                  </td>
                </tr>
              )}
              <tr className="bg-white">
                {/* <td className="p-2 text-center">{row.id}</td> */}
                <td className="p-2 relative">
                  <div className="flex flex-row items-center justify-between h-full">
                    <span>{row.particular}</span>
                    {row.isInfo && (
                      <Tooltip content={row}>
                        <img
                          src={infoSvg}
                          alt="info"
                          className="h-6 min-w-6 cursor-pointer"
                        />
                      </Tooltip>
                    )}
                  </div>
                </td>
                {row.pratham && !row.uttam && !row.param && (
                  <td className="p-2 relative" colSpan="3">
                    {renderCellContent(row.pratham, row.id, "pratham")}
                    {row.isPrathamExpanded && (
                      <button
                        onClick={() => toggleExpand(row.id, "pratham")}
                        className="absolute right-3 bottom-2"
                      >
                        <img
                          src={dropDownSvg}
                          alt="dropdown"
                          className={`h-6 w-6 cursor-pointer ${expandedRows[row.id]?.pratham ? "transform rotate-180" : ""}`}
                        />
                      </button>
                    )}
                  </td>
                )}
                {row.pratham && row.param && !row.uttam && (
                  <>
                    <td className="p-2 relative" colSpan="2">
                      {renderCellContent(row.pratham, row.id, "pratham")}
                      {row.isPrathamExpanded && (
                        <button
                          onClick={() => toggleExpand(row.id, "pratham")}
                          className="absolute right-3 bottom-2"
                        >
                          <img
                            src={dropDownSvg}
                            alt="dropdown"
                            className={`h-6 w-6 cursor-pointer ${expandedRows[row.id]?.pratham ? "transform rotate-180" : ""}`}
                          />
                        </button>
                      )}
                    </td>
                    <td className="p-2 relative">
                      {renderCellContent(row.param, row.id, "param")}
                      {row.isParamExpanded && (
                        <button
                          onClick={() => toggleExpand(row.id, "param")}
                          className="absolute right-3 bottom-2"
                        >
                          <img
                            src={dropDownSvg}
                            alt="dropdown"
                            className={`h-6 w-6 cursor-pointer ${expandedRows[row.id]?.param ? "transform rotate-180" : ""}`}
                          />
                        </button>
                      )}
                    </td>
                  </>
                )}
                {row.pratham && row.uttam && !row.param && (
                  <>
                    <td className="p-2 relative">
                      {renderCellContent(row.pratham, row.id, "pratham")}
                      {row.isPrathamExpanded && (
                        <button
                          onClick={() => toggleExpand(row.id, "pratham")}
                          className="absolute right-3 bottom-2"
                        >
                          <img
                            src={dropDownSvg}
                            alt="dropdown"
                            className={`h-6 w-6 cursor-pointer ${expandedRows[row.id]?.pratham ? "transform rotate-180" : ""}`}
                          />
                        </button>
                      )}
                    </td>
                    <td className="p-2 relative" colSpan="2">
                      {renderCellContent(row.uttam, row.id, "uttam")}
                      {row.isUttamExpanded && (
                        <button
                          onClick={() => toggleExpand(row.id, "uttam")}
                          className="absolute right-3 bottom-2"
                        >
                          <img
                            src={dropDownSvg}
                            alt="dropdown"
                            className={`h-6 w-6 cursor-pointer ${expandedRows[row.id]?.uttam ? "transform rotate-180" : ""}`}
                          />
                        </button>
                      )}
                    </td>
                  </>
                )}
                {row.pratham && row.uttam && row.param && (
                  <>
                    <td className="p-2 relative">
                      {renderCellContent(row.pratham, row.id, "pratham")}
                      {row.isPrathamExpanded && (
                        <button
                          onClick={() => toggleExpand(row.id, "pratham")}
                          className="absolute right-3 bottom-2"
                        >
                          <img
                            src={dropDownSvg}
                            alt="dropdown"
                            className={`h-6 w-6 cursor-pointer ${expandedRows[row.id]?.pratham ? "transform rotate-180" : ""}`}
                          />
                        </button>
                      )}
                    </td>
                    <td className="p-2 relative">
                      {renderCellContent(row.uttam, row.id, "uttam")}
                      {row.isUttamExpanded && (
                        <button
                          onClick={() => toggleExpand(row.id, "uttam")}
                          className="absolute right-3 bottom-2"
                        >
                          <img
                            src={dropDownSvg}
                            alt="dropdown"
                            className={`h-6 w-6 cursor-pointer ${expandedRows[row.id]?.uttam ? "transform rotate-180" : ""}`}
                          />
                        </button>
                      )}
                    </td>
                    <td className="p-2 relative">
                      {renderCellContent(row.param, row.id, "param")}
                      {row.isParamExpanded && (
                        <button
                          onClick={() => toggleExpand(row.id, "param")}
                          className="absolute right-3 bottom-2"
                        >
                          <img
                            src={dropDownSvg}
                            alt="dropdown"
                            className={`h-6 w-6 cursor-pointer ${expandedRows[row.id]?.param ? "transform rotate-180" : ""}`}
                          />
                        </button>
                      )}
                    </td>
                  </>
                )}
              </tr>
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default PlanComparison;
